import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/main.css";
import Logo404 from "../images/error404.png";

const Notfound = () => {
  return (
    <div>
      <Header />
      <div className="error404">
        <div class="container">
          <div className="background-img">
            <img src={Logo404} alt="logo error" />
          </div>
          <div className="info-box">
            <h2>Ups! Ai ajuns pe un drum necunoscut…</h2>
            <p>
              Pagina pe care o cauți nu există sau a fost mutată. Nu-ți face
              griji, te ajutăm să revii pe drumul cel bun!
            </p>
            <div className="redirect-button">
              <a className="button primary" href="/">
                Înapoi acasă
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Notfound;
